var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { Text } from '@ui';
import { InlineNameCell } from '@features/Attachments/components/InlineNameCell';
import { useAttachmentFieldCommit } from '../hooks/useAttachmentFieldCommit';
/**
 * Binds the shared inline `Name` cell to Invoice's single-field PATCH.
 *
 * A component rather than an inline closure in the surface config, because this has to go through
 * `useAttachmentFieldCommit` and hooks cannot run in that callback. Calling the API directly (as
 * an earlier draft did, copying the Work Order surface) skips the hook's React Query cache patch,
 * so the cached row kept the OLD name until a refetch — and every consumer that reads `row.name`
 * then used the stale value: search stopped matching the renamed row, and the delete dialog and
 * preview `aria-label` both showed the previous name (CodeRabbit, PR #23879).
 *
 * It also surfaces the server's own error. The earlier draft's `catch` discarded it and always
 * showed the generic string; the hook already extracts the server message when there is one.
 */
export function InvoiceAttachmentNameCell({ item, invoiceId, readOnly }) {
    const { commit } = useAttachmentFieldCommit(invoiceId, item.id);
    if (readOnly) {
        return React.createElement(Text, { variant: "body" }, item.name);
    }
    const commitName = (nextName) => __awaiter(this, void 0, void 0, function* () {
        const result = yield commit({ name: nextName });
        return result.success ? { success: true, name: result.row.name } : { success: false, error: result.error };
    });
    return React.createElement(InlineNameCell, { name: item.name, commitName: commitName });
}
